<div
    (click)="expandRow()"
    [ngClass]="{ 'tree-table': showExpandCollapse }"
    class="tCol clickCol"
    id="RowSelect1_{{ item.name }}"
    id="RowSelect1_{{ item.id }}"
>
    <app-resource-status [item]="item" [resourceType]="resourceType"></app-resource-status>
</div>
